
import {Observable,Subscription,Subject } from 'rxjs';

import { Dataset } from './4d-objects'

import { FourDService } from './4d-mapper.service'

import { Vasat } from 'vasat'



/*export class BaseProcessor{

	constructor(private file:File){

	}

	isSupported():boolean {
		return false
	}

	buildDataset():Dataset{
		return null
	}
}

export class BasicProcessor{

	constructor(private file:File){

	}

	isSupported():boolean {
		return true
	}

	buildDataset():Dataset{
		return null
	}
}*/

/**
 * <p>Processing Event. Includes </p>
 */
export class ServerProcess{
  uid:string
  dataset:any
  name:string
  status:string
  info:any
  progress:number
  error:any
  uploader:ChunkedFileUploader
  update(a:any):ServerProcess{
    Object.keys(a).forEach(k => 
      this[k] = a[k]
    )
    return this
  }
}

/**
 * <p>Interface that outlines common properties of an upload result.</p>
 */
export interface UploadRes{
	finished:boolean
  error:any
  status?:number
	aborted:any
    chunk:ChunkedFileUploader
}

/**
 * <p>Breaks files into manageable chunks for upload.</p>
 */
export class ChunkedFileUploader{

  loaded:number
  step:number = 5000000;
  total:number
  start:number
  progress:number

  progressSubject:Subject<number> = new Subject()
  progressObservable = this.progressSubject.asObservable()

  cnx:boolean

  fileRef:File
  retrysB4Fail = 5
  constructor(private V:Vasat, private url:string,chunkSize:number = 1000000){
    this.step = chunkSize
  }

  /**
   * <p>Cancels the current XMLHttpRequest.</p>
   */
  cancel(){
    this.cnx = true
    this.progressSubject.complete()
    if(this.currentXHR)
      this.currentXHR.abort()
  }

  currentXHR:XMLHttpRequest
  /**
   * <p>Uploads the a file by fragmenting it to smaller pieces depending on the given parameters.</p>
   * @param file File to upload.
   * @param startOffset Start of offset.
   * @param seqOffset The sequence number, where 0 is first.
   */
  uploadObservable(file,startOffset?:number,seqOffset?:number){
    this.start = startOffset||0;

    this.loaded = this.start;

    this.total = file.size;
    this.progress = 0
    var seq = seqOffset || 0;
    var reader = new FileReader();
    var self = this
    var finishSubject = new Subject<UploadRes>()
    var obs = finishSubject.asObservable()
    var errorCount = 0

    var blob = file.slice(self.start,self.loaded+self.step);
    var RETRYS = this.retrysB4Fail

    reader.onload = function(e){
        var xhr = new XMLHttpRequest();
        self.currentXHR = xhr
        var upload = xhr.upload;
        upload.addEventListener("progress", function(evt) {
           if (evt.lengthComputable) 
           {  
             self.progress = ((self.loaded + evt.loaded)/self.total);
             self.progressSubject.next(self.progress)

           } 
        },false);

        xhr.onreadystatechange = function() {
          if (xhr.readyState == XMLHttpRequest.DONE) {
            if(self.cnx){
              finishSubject.next({finished:false,error:null,aborted:true,chunk:self})
              finishSubject.complete()
              return
            }
            if(!xhr.responseText || xhr.responseText == ''){
             
              errorCount ++;
              if(errorCount >= RETRYS){
                  finishSubject.next({finished:false,error:{message:xhr.statusText,code:xhr.status},aborted:false,chunk:self})
                  finishSubject.complete()
              }
              else{
                console.log('Network error, trying again in 2 seconds')
                setTimeout(() => reader.readAsArrayBuffer(blob),2000)
              }
              return
            }
            var res = JSON.parse(xhr.responseText)
            
            if(res.status && res.status < 400){
              errorCount = 0
              self.loaded += self.step;
              
              
              if(self.loaded <= self.total){
                self.progress = (self.loaded/self.total) ;
                self.progressSubject.next(self.progress)

                blob = file.slice(self.loaded,self.loaded+self.step);
                reader.readAsArrayBuffer(blob)
              } else {
                self.progress = 1;
                self.progressSubject.next(1)

                self.loaded = self.total

                finishSubject.next({finished:true,error:null,aborted:true,chunk:self,status:res.status})
                finishSubject.complete()
              }
            }
            else{

            
              finishSubject.error({finished:false,error:res,aborted:false,chunk:self})
              finishSubject.complete()
              // TODO Make subject throw error
              //finishSubject.next({finished:false,error:res,aborted:false,chunk:self})
            }
            
          }
        }
       
        var url = self.url.startsWith(self.V.config.host)?self.url:self.V.config.host + self.url
        xhr.open("POST", url + "?seq=" + seq + "&offset=" + self.loaded + "&length=" + self.total + "&chunk=" + self.step + "&last=" + (self.loaded + self.step >= self.total));
        seq++;
        xhr.overrideMimeType("application/octet-stream");
        xhr.setRequestHeader('Content-Type','application/octet-stream')
        
        if(self.V && self.V.token){
          xhr.setRequestHeader('Authorization','Bearer ' + self.V.token)
        }
       
        xhr.send((<any>e.target).result);
       
    };
                
    reader.readAsArrayBuffer(blob); 

    return obs
  }
}


